import { MailboxInfo } from 'owa-client-ids';
import Item from 'owa-service/lib/contract/Item';
import { action } from 'satcheljs';

export const clearCachedAttachmentSuggestions = action(
    'clearCachedAttachmentSuggestions',
    function clearCachedAttachmentSuggestions(referenceItemId: string, composeId: string) {
        return {
            referenceItemId,
            composeId,
        };
    }
);

export const getAttachmentSuggestionsAction = action(
    'getAttachmentSuggestionsAction',
    function getAttachmentSuggestionsAction(
        referenceItem: Item,
        mailboxInfo: MailboxInfo,
        composeId: string
    ) {
        return {
            referenceItem,
            composeId,
        };
    }
);
